import { axiosChartInstance } from "config";
import { useAxiosMutation } from "hooks";
import { useQueryClient } from "react-query";

function useDeleteProgressFavorite(id: string) {
  const queryClient = useQueryClient();

  return useAxiosMutation(
    ["deleteProgressFavorite"],
    () => axiosChartInstance.delete(`v1/chart-progress-favorite/${id}`),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["progressFavorites"]);
      },
    }
  );
}

export { useDeleteProgressFavorite };
